import { useTranslate } from 'hooks/useTranslate';
import React, { FC } from 'react';
import { Modal } from 'react-bootstrap';

type Props = {
  pauseStartDate: string;
  pauseEndDate: string;
  isIndefinitePause: boolean;
  handlePauseBeneficiary: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const PauseBeneficiaryFooter: FC<Props> = ({
  pauseStartDate,
  pauseEndDate,
  isIndefinitePause,
  handlePauseBeneficiary,
}) => {
  const { t } = useTranslate();

  const isFormValid = () => {
    if (!pauseStartDate) return false;
    if (!isIndefinitePause && !pauseEndDate) return false;
    if (
      !isIndefinitePause &&
      pauseEndDate &&
      pauseEndDate < pauseStartDate
    ) {
      return false;
    }
    return true;
  };

  return (
    <Modal.Footer>
      <button
        type="submit"
        className="btn btn-lg btn-primary"
        onClick={handlePauseBeneficiary}
        disabled={!isFormValid()}
      >
        {t('ExecutePause')}
      </button>
    </Modal.Footer>
  );
};

export default PauseBeneficiaryFooter;

